var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBtnUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12141 12.325C9.28569 12.2429 9.36783 12.0786 9.36783 11.9143C9.36783 11.75 9.36783 11.5857 9.28569 11.5036C9.03926 11.175 8.71069 11.175 8.46426 11.2572C7.06783 11.6679 5.34283 13.7215 5.34283 15.5286V16.1036H11.0928H17.2535V15.5286C17.2535 13.475 15.775 11.4215 13.6393 10.6822C14.2964 10.025 14.7071 9.12145 14.7071 8.21788C14.7071 6.3286 13.1464 4.76788 11.2571 4.76788C9.36783 4.76788 7.80712 6.3286 7.80712 8.21788C7.80712 10.1072 9.36783 11.6679 11.2571 11.6679H11.4214C13.5571 11.6679 15.4464 12.9822 15.6928 14.7893H11.2571H6.90355C7.23212 13.5572 8.62855 12.5715 9.12141 12.325ZM13.2285 8.30003C13.2285 9.45003 12.2428 10.3536 11.175 10.3536C10.025 10.3536 9.12141 9.36788 9.12141 8.30003C9.12141 7.15003 10.1071 6.24645 11.175 6.24645C12.2428 6.24645 13.2285 7.06788 13.2285 8.30003Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.175 0.25C5.09643 0.25 0.25 5.17857 0.25 11.175C0.25 17.1714 5.17857 22.1 11.175 22.1C13.7214 22.1 16.0214 21.2786 17.9929 19.7179C18.1571 19.5536 18.3214 19.3893 18.3214 19.1429C18.3214 18.8964 18.3214 18.7321 18.1571 18.4857C17.8286 18.1571 17.3357 18.075 17.0071 18.3214C15.3643 19.6357 13.3929 20.2929 11.2571 20.2929C6.16429 20.2929 1.975 16.1857 1.975 11.0107C1.89286 6.08214 6.08214 1.975 11.175 1.975C16.2679 1.975 20.4571 6.08214 20.4571 11.175C20.4571 12.9 19.9643 14.625 19.0607 16.0214C18.9786 16.1857 18.8964 16.4321 18.9786 16.6786C19.0607 16.925 19.1429 17.0893 19.3893 17.1714C19.8 17.4179 20.2929 17.3357 20.5393 16.925C21.6071 15.2 22.1821 13.2286 22.1821 11.175C22.1 5.17857 17.1714 0.25 11.175 0.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBtnUser);
export default __webpack_public_path__ + "static/media/nav_btn_user.51015c9362f9cbff48dffdae1c33a0c8.svg";
export { ForwardRef as ReactComponent };